import 'react-app-polyfill/ie11';

import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';

import { Provider } from 'react-redux';
import store from './store.js';

import { HashRouter } from 'react-router-dom';

import ScrollToTop from './ScrollToTop';

import {
    captureJweFromUrl,
    installJweInterceptor,
    installJweExpiredInterceptor,
    getJwe,
    initializeNeaSession
} from './service/JweSession';


// ============================================================
// HANDOFF LEGACY -> NEA
// ============================================================

/*
 * 1. Capture le JWE éventuellement présent dans l'URL.
 *
 * Si un nouveau JWE est détecté :
 *   => ancienne session NEA supprimée
 *
 * 2. Installe l'intercepteur Authorization Bearer.
 *
 * 3. Installe l'intercepteur d'expiration JWE.
 */
captureJweFromUrl();

installJweInterceptor();

installJweExpiredInterceptor();


// ============================================================
// APPLICATION INITIALIZATION
// ============================================================

const initializeApp = async () => {

    /*
     * Aucun appel de création de session si aucun JWE
     * n'est présent.
     */
    if (getJwe()) {

        await initializeNeaSession();
    }


    // ========================================================
    // RENDER REACT
    // ========================================================

    ReactDOM.render(
        <HashRouter>
            <ScrollToTop>
                <Provider store={store}>
                    <App />
                </Provider>
            </ScrollToTop>
        </HashRouter>,
        document.getElementById('root')
    );
};


// ============================================================
// START APPLICATION
// ============================================================

initializeApp();

